import React from "react";
import Select from "react-select";
import { useField, useFormikContext } from "formik";

const FormikMultiSelectDropdown = ({
    label,
    name,
    options = [], // Pre-provided options
    placeholder = "Select",
    required = false,
    disabled = false,
    needSearch = true,
    ...props
}) => {
    const { setFieldValue } = useFormikContext();
    const [field, meta] = useField(name);

    const fieldValue = field.value || []; // Ensure field value is always an array

    const handleChange = (selectedOptions) => {
        const selectedValues = selectedOptions
            ? selectedOptions.map((option) => option.value)
            : [];
        setFieldValue(name, selectedValues);
        if (props.onChange) {
            props.onChange(selectedOptions); // Call the parent onChange if provided
        }
    };

    return (
        <div className="form-control flex flex-col gap-2 p-2 text-xs">
            {/* Label */}
            {label && (
                <label htmlFor={name} className="font-medium flex items-center text-xs">
                    {label}
                    {required && <span className="text-red-600 font-bold ml-1 text-xs">*</span>}
                </label>
            )}
            <Select
                options={options}
                value={options.filter((option) => fieldValue.includes(option.value))}
                onChange={handleChange}
                classNamePrefix="react-select"
                className="text-xs"
                placeholder={placeholder}
                isMulti={true}
                isSearchable={needSearch}
                isDisabled={disabled}
                noOptionsMessage={() => "No options available"}
            />

            {/* Error Message */}
            {meta.touched && meta.error && (
                <p className="mt-2 text-sm text-red-500" id={`${name}-error`}>
                    {meta.error}
                </p>
            )}
        </div>
    );
};

export default FormikMultiSelectDropdown;
